import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import showMessage from 'components/Message';

import nftServices from 'services/nft';
import { checkSusscessRequest } from 'services/api';

import TYPE_CONSTANTS from 'constants/type';
import { renderRoutes, routeURLs } from 'constants/routes';

export const useCreateOrEditNFT = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const handleEditNFT = async (data: any, id: string, onFinally: any) => {
    setLoading(true);
    try {
      const response = await nftServices.handleUpdateIPFS(data, id);
      if (checkSusscessRequest(response)) {
        showMessage(TYPE_CONSTANTS.MESSAGE.SUCCESS, 'message.S3');
        // history.push(renderRoutes.NFT_DETAIL(response?.data?._id));
      }
    } catch (error) {
    } finally {
      setLoading(false);
      onFinally();
    }
  };

  return {
    loading,
    onEditNFT: handleEditNFT,
  };
};

export const useGetDetailNFT = (id: string) => {
  const history = useHistory();
  const [nftDetail, setNftDetail] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      handleGetNftDetail(id);
    }
  }, [id]);

  const handleGetNftDetail = async (id: string) => {
    setLoading(true);
    try {
      const response = await nftServices.handleGetNftDetail(id);
      if (checkSusscessRequest(response)) {
        setNftDetail(response?.data?.[0]);
      } else {
        history.push(routeURLs.HOME);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return {
    nftDetail,
    loading,
    onGetNftDetail: handleGetNftDetail,
  };
};
